let routes = [
    {
      path: '/authenticate',
      component: () => import('../views/Authenticate.vue'),
    }
  
  ]
  
  export default routes;